"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _excluded = ["name", "iso2", "dialCode", "localization", "itemRef", "native"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // The MIT License (MIT)
// Copyright (c) 2015 Raza Gill
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
var Item = /*#__PURE__*/function (_React$PureComponent) {
  function Item() {
    (0, _classCallCheck2["default"])(this, Item);
    return _callSuper(this, Item, arguments);
  }
  (0, _inherits2["default"])(Item, _React$PureComponent);
  return (0, _createClass2["default"])(Item, [{
    key: "render",
    value: function render() {
      var ref = /*#__PURE__*/_react["default"].createRef();
      var _this$props = this.props,
        name = _this$props.name,
        iso2 = _this$props.iso2,
        dialCode = _this$props.dialCode,
        localization = _this$props.localization,
        itemRef = _this$props.itemRef,
        _native = _this$props["native"],
        restProps = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      if (_native) {
        return /*#__PURE__*/_react["default"].createElement("option", (0, _extends2["default"])({
          className: "country",
          "data-dial-code": "1",
          "data-country-code": iso2,
          value: iso2
        }, restProps), localization || name, " ", "+".concat(dialCode));
      }
      return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], (0, _extends2["default"])({
        ref: ref,
        className: "country",
        "data-dial-code": "1",
        "data-country-code": iso2
      }, restProps), /*#__PURE__*/_react["default"].createElement("div", {
        className: "flag ".concat(iso2, " margin")
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "country-name"
      }, localization || name), /*#__PURE__*/_react["default"].createElement("span", {
        className: "dial-code"
      }, "+".concat(dialCode)));
    }
  }]);
}(_react["default"].PureComponent);
Item.propTypes = {
  name: _propTypes["default"].string.isRequired,
  iso2: _propTypes["default"].string.isRequired,
  dialCode: _propTypes["default"].string.isRequired,
  itemRef: _propTypes["default"].func.isRequired,
  localization: _propTypes["default"].string,
  "native": _propTypes["default"].bool
};
Item.defaultProps = {
  localization: null,
  "native": false
};
var _default = exports["default"] = Item;